// src/ProtectedRoute.jsx
import { useState, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import customAxios from "lib/axios";
import PropTypes from "prop-types";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const userId = localStorage.getItem("user_id");
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    const { courseId } = rest.computedMatch.params;
    customAxios
      .get(`/userCourse/user/course/${courseId}`)
      .then(() => setAllowed(true))
      .catch(() => setAllowed(false));
  }, [rest.computedMatch.params.courseId, userId]);

  if (allowed === null) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        allowed ? <Component {...props} /> : <Redirect to="/myCourses" />
      }
    />
  );
};
ProtectedRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
};

export default ProtectedRoute;
